import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addRoleMut = loader('./roles.add.graphql');
const editRoleMut = loader('./roles.edit.graphql');
const addRequirementMut = loader('./roles.addRequirement.graphql');
const deleteRequirementMut = loader('./roles.deleteRequirement.graphql');
const createRequirementMut = loader('./requirement.add.graphql');
const deleteReqMut = loader('./requirement.delete.graphql');
const addRoleToUserMut = loader('./roles.addToUser.graphql');
const removeRoleFromUserMut = loader('./roles.removeRoleFromUser.graphql');
const bulkAddUsersToRoleMut = loader('./roles.bulkAddUsers.graphql');
const bulkRemoveUsersFromRoleMut = loader('./roles.bulkRemoveUsers.graphql');

export const useRoleMutations = () => {
  const [addRoleMutation] = useMutation(addRoleMut);
  const [addRoleToUserMutation] = useMutation(addRoleToUserMut);
  const [removeRoleFromUserMutation] = useMutation(removeRoleFromUserMut);
  const [bulkAddUsersToRoleMutation] = useMutation(bulkAddUsersToRoleMut);
  const [bulkRemoveUsersFromRoleMutation] = useMutation(
    bulkRemoveUsersFromRoleMut,
  );

  const bulkAddUsersToRole = async ({
    roleId,
    userIds,
    onComplete = () => {},
  }) => {
    await bulkAddUsersToRoleMutation({ variables: { roleId, userIds } }).then(
      () => onComplete(),
    );
  };
  const bulkRemoveUsersFromRole = async ({
    roleId,
    userIds,
    onComplete = () => {},
  }) => {
    await bulkRemoveUsersFromRoleMutation({
      variables: { roleId, userIds },
    }).then(() => onComplete());
  };

  const removeRoleFromUser = async ({
    roleId,
    userId,
    onComplete = () => {},
  }) => {
    await removeRoleFromUserMutation({ variables: { roleId, userId } }).then(
      () => onComplete(),
    );
  };
  const addRoleToUser = async ({ roleId, userId, onComplete = () => {} }) => {
    await addRoleToUserMutation({ variables: { roleId, userId } }).then(() =>
      onComplete(),
    );
  };

  const addRole = async ({ title, description, onComplete = () => {} }) => {
    await addRoleMutation({
      variables: { title, description },
    }).then(() => onComplete());
  };
  const [editRoleMutation] = useMutation(editRoleMut);

  const editRole = async ({
    roleId,
    title,
    description,
    permissions,
    reportToId,
    onComplete = () => {},
  }) => {
    await editRoleMutation({
      variables: { roleId, title, description, permissions, reportToId },
    }).then((r) => onComplete(r));
  };
  const [addRequirementMutation] = useMutation(addRequirementMut);

  const addRoleRequirement = async ({ roleId, requirementId }) => {
    await addRequirementMutation({
      variables: { roleId, requirementId },
    });
  };
  const [deleteReqMutation] = useMutation(deleteReqMut);

  const deleteRequirement = async ({ id, onComplete = () => {} }) => {
    await deleteReqMutation({
      variables: { id },
    }).then(() => onComplete());
  };
  const [addReqMutation] = useMutation(createRequirementMut);

  const createRequirement = async ({ title, description }) => {
    return await addReqMutation({
      variables: { title, description },
    });
  };
  const [deleteRequirementMutation] = useMutation(deleteRequirementMut);

  const deleteRoleRequirement = async ({
    roleId,
    requirementId,
    onComplete = () => {},
  }) => {
    await deleteRequirementMutation({
      variables: { roleId, requirementId },
    }).then(() => onComplete());
  };

  return {
    addRole,
    editRole,
    addRoleRequirement,
    deleteRoleRequirement,
    createRequirement,
    deleteRequirement,
    addRoleToUser,
    removeRoleFromUser,
    bulkAddUsersToRole,
    bulkRemoveUsersFromRole,
  };
};
